export const siteInfo = {
  name: '瓜圈速报',
  shortName: '瓜圈',
  slogan: '吃瓜不迷路，热点先一步',
  description:
    '瓜圈速报是一个专注娱乐舆情的信息聚合站，用热度排行、话题榜和速报快讯三件事，帮你在信息洪流里快速找到今天真正值得围观的那口瓜。',
  email: 'hi@guaquan.example.com',
  updateNote: '榜单热度每 10 分钟刷新一次，数据综合公开讨论量、搜索热度与传播速度加权得出。',
  stats: [
    { label: '今日收录热点', value: '1,286', unit: '条' },
    { label: '在榜话题', value: '86', unit: '个' },
    { label: '累计围观', value: '2,470', unit: '万' },
    { label: '榜单更新间隔', value: '10', unit: '分钟' },
  ],
};

export const navItems = [
  { label: '首页', path: '/' },
  { label: '热度排行', path: '/ranking' },
  { label: '话题榜', path: '/topics' },
  { label: '关于我们', path: '/about' },
];

export const marqueeTips = [
  '恋情观察 · 同款行程重合引发全网考古',
  '影视风向 · 暑期档古装剧口碑从 6.2 涨到 8.1',
  '综艺名场面 · 救场三分钟成为本季最高播放片段',
  '舞台与音乐 · 音乐节预售秒空，票务系统告急',
  '榜单数据 · 艺人新媒体指数前三名差距不足 0.3',
  '品牌联名 · 国货×动漫联名上线十分钟售罄',
];